import React, { useState, useRef, useEffect } from 'react';
import { Dropdown, Divider, Input, Button } from '@fuxi/eevee-ui';
import MyIcon from '@/components/MyIcon';
import { eventEmitter } from '@/utils/eventEmitter';
import { PlayerViewerEvent } from '@/components/PlayViewerControl';
import { keepTwoDecimal } from './util';
import cx from './index.module.css';

interface PlayRateDropdownProps {
  originalFrameRate: number;
  frameRate: number;
  onFrameRateChange: (frameRate: number, speedRatio: number) => void;
}

export interface FrameRateEmitterProps {
  originalFrameRate: number;
  frameRate: number;
}

const rationOptions = [3, 2, 1.5, 1.25, 1, 0.75, 0.5]; // 帧率动态计算 , 改成倍率

const PlayRateDropdown: React.FC<PlayRateDropdownProps> = ({ originalFrameRate, frameRate, onFrameRateChange }) => {
  const [frameRateInput, setFrameRateInput] = useState<number | string>('');
  const dropdownBtnRef = useRef<any>(null);

  const handleClose = () => {
    dropdownBtnRef?.current?.click();
  };

  const frameRateFilter = (frameRate, originalFrameRate) => {
    const min = Number((0.0626 * originalFrameRate).toFixed(2));
    const max = 16 * originalFrameRate;

    let val = Number(Number(frameRate).toFixed(2));
    val < min && (val = min);
    val > max && (val = max);
    return val;
  };

  const beforeFrameRateChange = () => {
    const val = frameRateFilter(frameRateInput, originalFrameRate);
    setFrameRateInput(val);
    onFrameRateChange(val, val / originalFrameRate);
    handleClose();
  };

  useEffect(() => {
    // feat: frameRate change when origin toogle.
    const handleFrameRateEmitter = (props: FrameRateEmitterProps) => {
      const { frameRate, originalFrameRate } = props;
      const val = frameRateFilter(frameRate, originalFrameRate);
      setFrameRateInput(val);
      onFrameRateChange(val, val / originalFrameRate);
    };
    eventEmitter.on(PlayerViewerEvent.iframeRate, handleFrameRateEmitter);
    return () => {
      eventEmitter.off(PlayerViewerEvent.iframeRate, handleFrameRateEmitter);
    };
  }, []);

  return (
    <div className={cx('play-rate-dropdown')}>
      <MyIcon icon="zhenlv" size={24}></MyIcon>
      <Dropdown
        destroyPopupOnHide
        trigger={['click']}
        overlayStyle={{ padding: 0 }}
        overlayClassName={cx('frame-dropdown')}
        dropdownRender={() => {
          return (
            <>
              <div className={cx('frame-dropdown-header')}>
                <span className={cx('key')}>帧率</span>
                <span className={cx('value')}>倍率</span>
              </div>
              <Divider style={{ marginBlock: '0 4px' }} />
              <div className={cx('frame-dropdown-content')}>
                {rationOptions.map((speedRatio, index) => {
                  return (
                    <div
                      key={index}
                      className={cx(
                        'frame-dropdown-content-item',
                        `${frameRate === originalFrameRate * speedRatio && 'frame-dropdown-content-item--active'}`,
                      )}
                      onClick={() => {
                        onFrameRateChange(originalFrameRate * speedRatio, speedRatio);
                        setFrameRateInput(originalFrameRate * speedRatio);
                        //   setFrameRate(originalFrameRate * speedRatio);
                        //   playerRef?.current?.setSpeedRatio(speedRatio);
                      }}>
                      <div className={cx('key')}>{`${keepTwoDecimal(originalFrameRate * speedRatio)}fps`}</div>
                      <div className={cx('value')}>{`${speedRatio}x`}</div>
                      {speedRatio === 1 && <span>原始帧率</span>}
                    </div>
                  );
                })}
              </div>
              <Divider style={{ marginBlock: '4px 0' }} />
              <div className={cx('frame-dropdown-footer')}>
                <Input
                  style={{ flex: 1 }}
                  value={frameRateInput}
                  onChange={e => {
                    if (!isNaN(Number(e.target.value))) return setFrameRateInput(e.target.value);
                  }}
                  autoFocus={true}
                  placeholder="自定义帧率"
                  onPressEnter={e => beforeFrameRateChange()}
                />
                <Button
                  type="link"
                  style={{
                    color: 'rgba(126, 135, 255, 1)',
                    paddingInline: '12px',
                  }}
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    beforeFrameRateChange();
                  }}>
                  <span className={cx('frame-dropdown-btn')}>确定</span>
                </Button>
              </div>
            </>
          );
        }}>
        <span ref={dropdownBtnRef} className={cx('play-rate-dropdown-btn')}>{`${frameRate.toFixed(2)}fps-${(
          frameRate / originalFrameRate
        ).toFixed(2)}x`}</span>
      </Dropdown>
    </div>
  );
};

export default React.memo(PlayRateDropdown);
